import { Brand } from '@blade/std-lib'

export const PositionIdTypeId = 'tradebot-tma/PositionId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PositionIdTypeId = typeof PositionIdTypeId
export type PositionId = Brand.Branded<string, PositionIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PositionId = Brand.nominal<PositionId>()

export const AggregatedPositionIdTypeId = 'tradebot-tma/AggregatedPositionId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AggregatedPositionIdTypeId = typeof AggregatedPositionIdTypeId
export type AggregatedPositionId = Brand.Branded<
  PositionId,
  AggregatedPositionIdTypeId
>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AggregatedPositionId = Brand.nominal<AggregatedPositionId>()

// @ts-expect-error AggregatedPositionId is subtype of the PositionId
const _supertypeTest: AggregatedPositionId = PositionId('test')
const _subtypeTest: PositionId = AggregatedPositionId('test')
